import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'
import { GetApplicationInterviewsQuery } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'

import { InterviewDetail } from './InterviewDetail'
import { useApplicationInterviews } from './useApplicationInterviews'

type AtsInterview = NonNullable<
  NonNullable<NonNullable<GetApplicationInterviewsQuery['ats']>['interviewsConnection']>['nodes']
>[0]

interface Props {
  applicationId: string
}

export const InterviewListing = ({ applicationId }: Props) => {
  const { interviews } = useApplicationInterviews(applicationId)
  const { featureAvailability } = useFeatureAvailability(Features.ats_interview_scheduling)
  const canSeeInterviews = interviews?.length && featureAvailability?.available

  if (!canSeeInterviews) return null

  const orderedInterviews = orderBy(interviews, [
    (interview) => {
      switch (interview.status) {
        case 'scheduled':
          return 1
        case 'processing':
          return 1
        case 'completed':
          return 3
        default:
          return 4
      }
    },
    'startsAt',
  ])

  return (
    <Box gap="s16">
      {orderedInterviews.map((interview) => (
        <InterviewDetail key={`interview-${interview.id}`} interview={interview as AtsInterview} />
      ))}
    </Box>
  )
}
